<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-10-24 17:45:40
 * @LastEditors: 侯鹏许
 * @LastEditTime: 2021-03-25 17:14:44
 * @Description: file content
 -->
<template>
  <div class="index_house">
    <div class="person-wrap" ref="personWrap">
      <ul ref="personTab">
        <li
          class="scroll-view-item_W"
          v-for="(item,index) in newList"
          :key="index"
          @click="tapHouseDetail"
        >
          <!-- <img
            class="wc-preview-img"
            :src="item.img"
            @click="$preview($event, newList, index,'detail')"
          >-->
          <img :src="item.compress_img" alt @click="showBigImg(item.main_img, index)" />
          <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
    <wimg
      style="z-index: 10000;"
      :show="isShowBigImg"
      :imgs="imgList"
      :currentImg="current"
      @close="isShowBigImg = false"
    ></wimg>
  </div>
</template>

<script>
import Vue from "vue";
import BScroll from "better-scroll";
import wcView from "wc-view";
import "wc-view/style.css";
import wimg from "w-previewimg";
import wxsdk from "@/utils/wxsdk";
import util from "@/utils/utils";
Vue.use(wcView);
export default {
  components: {
    wimg
  },
  props: {
    list: Array
  },
  data() {
    return {
      scroll: null,
      isShowBigImg: false,
      current: "",
      imgList: [],
      newList: []
    };
  },
  watch: {},
  computed: {},
  methods: {
    showBigImg(i, index) {
      if (util.checkIsHuafa()) {
        let url = `${location.protocol}//${location.host}/h5/t7_housedetail?index=${index}`;
        util.openYqRsMakeLink(url);
      } else {
        this.current = i;
        this.isShowBigImg = true;
        wxsdk.wx.previewImage({
          current: this.current,
          urls: this.imgList
        });
      }
    },
    personScroll() {
      if (this.newList) {
        // 默认有六个li子元素，每个子元素的宽度为120px
        let width = this.newList.length * 170;
        this.$refs.personTab.style.width = width + "px";
        // this.$nextTick 是一个异步函数，为了确保 DOM 已经渲染
        this.$nextTick(() => {
          if (!this.scroll) {
            this.scroll = new BScroll(this.$refs.personWrap, {
              startX: 0,
              click: true,
              scrollX: true,
              // 忽略竖直方向的滚动
              scrollY: false,
              eventPassthrough: "vertical"
            });
          } else {
            this.scroll.refresh();
          }
        });
      }
    },
    tapHouseDetail() {}
  },
  created() {
    if (this.list) {
      this.newList = this.list.filter(e => {
        if (e && typeof e == "object") {
          return true;
        }
        return false;
      });
      this.newList.forEach(e => {
        this.imgList.push(e.main_img);
      });
      this.$nextTick(() => {
        this.personScroll();
      });
    }
  },
  mounted() {}
};
</script>
<style lang="css">
.zhezhao img {
  width: 100%;
}
</style>
<style lang="css" scoped>
.person-wrap {
  overflow: hidden;
}
.scroll-view-item_W {
  width: 150px;
  height: 180px;
  background: #fff;
  margin: 15px 10px;
  display: inline-block;
  border-radius: 0.125rem;
  /* box-shadow: 0 0 0.25rem #cbcbcb; */
}

.scroll-view-item_W img {
  width: 150px;
  height: 150px;
  box-shadow: 0 0 0.25rem #cbcbcb;
}
.scroll-view-item_W > p {
  width: 100%;
  text-align: center;
  line-height: 0.6rem;
  height: 0.6rem;
  color: #333333;
  font-size: 0.24rem;
}
</style>